// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fFv7UGdXZmgqiRzqfke5{z-index:var(--zIndex-BASE_3);padding:4px 0;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `fFv7UGdXZmgqiRzqfke5`
};
export default ___CSS_LOADER_EXPORT___;
